/**
 * 适配移动端
 */
export const mixins = {
  mounted() {
    // 在组件挂载后替换meta标签
    this.replaceMetaTags();
  },
  methods: {
    replaceMetaTags() {
      // 移除旧的meta标签
      const existingMeta = document.querySelector('meta[name="viewport"]');
      existingMeta.content = "width=device-width,initial-scale=1.0";
    },
  },
  beforeDestroy() {
    const existingMeta = document.querySelector('meta[name="viewport"]');
    existingMeta.content = "width=1200,initial-scale=0.2";
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/metaMixins.js